module.exports = __webpack_public_path__ + "static/home-d2880ca76a644168623584131f81587f.jpg";